export default __webpack_public_path__ + "static/media/detoxdrinks@2x.5f2a6237.jpg";